import React, { useEffect, useState, useCallback, useMemo } from "react";
import Styles from "./Banking_Ledger.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ActiveConnections from "./ActiveConnections/ActiveConnections";
import OngoingBanking from "./OngoingBanking/OngoingBanking";
import OngoingPopup from "../../../commons/PopupModal/BankingPopup/OngoingPopup/OngoingPopup";
import {
  fetchConnectionHistory,
  fetchLedgerBanking,
  fetchLedgerOngoing,
} from "../../../Redux/Slices/bankingSlice";

const BankingLedger = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState("Active Connections");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState();
  const [ongoingPopupOpen, setOngoingPopupOpen] = useState(false);
  const [ongoingPopupShown, setOngoingPopupShown] = useState(false);
  const [userSelectedTab, setUserSelectedTab] = useState(false);

  const { ledgerBankingData, loading } = useSelector(
    (state) => state.bankingSlice,
  );

  const { ledgerOngoingData } = useSelector((state) => state.bankingSlice);

  const pagedItemsBanking = Array.isArray(ledgerBankingData?.page)
    ? ledgerBankingData.page
    : [];

  const activeListingIdBanking = pagedItemsBanking
    .map((item) => item.selfListing?.id)
    .filter(Boolean);

  const paginatedCurrentPageBanking =
    ledgerBankingData?.currentPage ?? currentPage;
  const paginatedSizeBanking = ledgerBankingData?.size ?? itemsPerPage;
  const totalElementsBanking =
    ledgerBankingData?.totalElements ?? pagedItemsBanking.length;

  const pagedItemsOngoing = useMemo(
    () => ledgerOngoingData?.page || [],
    [ledgerOngoingData],
  );
  const activeListingIdOngoing = pagedItemsOngoing
    .map((item) => item?.bankingListing?.id)
    .filter(Boolean);
  const paginatedCurrentPageOngoing = ledgerOngoingData?.currentPage ?? 0;
  const paginatedSizeOngoing = ledgerOngoingData?.size ?? 10;
  const totalElementsOngoing = ledgerOngoingData?.totalElements ?? 0;

  useEffect(() => {
    if (location.state?.activeTab) {
      if (
        location.state.activeTab === "ongoing" ||
        location.state.activeTab === "Ongoing Banking"
      ) {
        setActiveTab("Ongoing Banking");
      } else if (location.state.activeTab === "Active Connections") {
        setActiveTab("Active Connections");
      }

      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
    if (!location.state?.activeTab && ledgerBankingData && pagedItemsOngoing) {
      const hasLedgerBanking =
        Array.isArray(ledgerBankingData) &&
        ledgerBankingData.some(
          (item) => item?.selfListing?.status?.toLowerCase() === "ledger",
        );
      const hasLedgerOngoing =
        Array.isArray(pagedItemsOngoing) &&
        pagedItemsOngoing.some(
          (item) => item?.bankingListing?.status?.toLowerCase() === "ledger",
        );
      if (hasLedgerBanking || hasLedgerOngoing) {
        setActiveTab("Ongoing Banking");
      }
    }
  }, [ledgerBankingData, pagedItemsOngoing, location.state]);

  useEffect(() => {
    if (activeTab === "Active Connections") {
      dispatch(fetchLedgerBanking({ currentPage, size: itemsPerPage }));
    } else if (activeTab === "Ongoing Banking") {
      dispatch(fetchLedgerOngoing({ currentPage, size: itemsPerPage }));
    }
  }, [dispatch, currentPage, itemsPerPage, activeTab]);

  useEffect(() => {
    setCurrentPage(0);
  }, [activeTab]);

  const handleDocsUploaded = () => {
    dispatch(fetchLedgerBanking({ currentPage, size: itemsPerPage }));
  };

  const handleAgreementAccepted = useCallback(() => {
    setOngoingPopupOpen(true);
    setOngoingPopupShown(true);
  }, []);

  const handleOngoingPopupConfirm = useCallback(() => {
    setOngoingPopupOpen(false);
    setActiveTab("Ongoing Banking");
    setUserSelectedTab(true);
    dispatch(fetchLedgerOngoing({ currentPage: 0, size: itemsPerPage }));
  }, [dispatch, itemsPerPage]);

  const handleOngoingPopupClose = useCallback(() => {
    setOngoingPopupOpen(false);
    setOngoingPopupShown(false);
  }, []);

  const handleTabClick = useCallback((tabName) => {
    setActiveTab(tabName);
    setUserSelectedTab(true);
    setOngoingPopupOpen(false);
  }, []);

  const handleConnectionHistoryClick = (listingId) => {
    if (listingId) {
      dispatch(fetchConnectionHistory(listingId));
    }
  };

  return (
    <>
      {ongoingPopupOpen && (
        <OngoingPopup
          open={ongoingPopupOpen}
          handleClose={handleOngoingPopupClose}
          onConfirm={handleOngoingPopupConfirm}
          buttonText="Go To Ongoing"
        />
      )}

      <div className={Styles.bankingSearchMainCont}>
        <div className={Styles.bankingSearchHead}>
          <div className={Styles.bankingLedgerBack}>
            <div
              className={Styles.receivedBackButton}
              onClick={() => navigate(`/banking`)}
            >
              <ArrowBackIosIcon
                style={{
                  width: "10px",
                  height: "10px",
                  paddingTop: "3px",
                  // paddingRight: "5%",
                }}
              />
              Back
            </div>
            <div className={Styles.receivedHeading}>
              {activeTab === "Active Connections"
                ? "Active Connections"
                : "Ongoing Banking"}
            </div>
          </div>
          <div className={Styles.sideButtonsLedger}>
            {/* <div
              className={
                activeTab === "Active Connections"
                  ? Styles.activeTab
                  : Styles.inActiveTab
              }
              onClick={() => handleTabClick("Active Connections")}
            >
              Active Connections
            </div> */}
            {/* <div
              className={
                activeTab === "Ongoing Banking"
                  ? Styles.activeTab
                  : Styles.inActiveTab
              }
              onClick={() => handleTabClick("Ongoing Banking")}
            >
              Ongoing Banking
            </div> */}
          </div>
        </div>

        <div className={Styles.activeTableConnections}>
          {activeTab === "Active Connections" && (
            <ActiveConnections
              isLoading={loading}
              data={pagedItemsBanking}
              activeListingId={activeListingIdBanking}
              onAllDocsUploaded={handleDocsUploaded}
              onAgreementAccepted={handleAgreementAccepted}
              currentPage={paginatedCurrentPageBanking}
              itemsPerPage={paginatedSizeBanking}
              totalCount={totalElementsBanking}
              onPageChange={setCurrentPage}
            />
          )}
          {activeTab === "Ongoing Banking" && (
            <OngoingBanking
              isLoading={loading}
              data={pagedItemsOngoing}
              activeListingId={activeListingIdOngoing}
              currentPage={paginatedCurrentPageOngoing}
              itemsPerPage={paginatedSizeOngoing}
              totalCount={totalElementsOngoing}
              onPageChange={setCurrentPage}
              onConnectionHistoryClick={handleConnectionHistoryClick}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default BankingLedger;
